import React from 'react'

import { EmployeeReimbursementsDue } from 'core/application/adminDashboard/reimbursements/reimbursementsDue/getReimbursementsDue'

import { formatMoney } from 'common/moneyFormatter'

import './TotalReimbursementsDue.less'

interface TotalReimbursementsDueProps {
  reimbursementsDue: EmployeeReimbursementsDue[]
  translate: (key: string) => string
}

const TotalReimbursementsDue: React.FC<TotalReimbursementsDueProps> = ({ reimbursementsDue, translate }) => {
  return reimbursementsDue.length > 0 ? (
    <div className="total_reimbursements_due">
      <h6 className="pr-40">{translate('admin-dashboard.reimbursements.reimbursements-due.total-label')}:</h6>
      <h6>{formatMoney(reimbursementsDue.reduce((total, current) => total + current.reimbursementsDue, 0))}</h6>
    </div>
  ) : (
    <div></div>
  )
}

export default TotalReimbursementsDue
